export default __webpack_public_path__ + "static/media/logo-color.cc2c7c3f.png";